<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-toolbar dark dense flat>
        <v-toolbar-title class="headline">{{ "Edit package" }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon @click="close()">close</v-icon> </v-toolbar
      ><v-card-text>
        <div style="font-weight: bold">
          Store name: <span style="color: grey">{{ storeName }}</span>
        </div>
        <v-form v-model="valid" ref="formEditPackage">
          <v-layout wrap>
            <v-flex xs12 sm8 class="pa-1">
              <v-autocomplete
                label="Select Package"
                :items="productList"
                :loading="isLoadingProduct"
                color="black"
                v-model="form.product_id"
                hide-no-data
                hide-selected
                item-text="product_name_th"
                item-value="product_id"
              >
                <template slot="item" slot-scope="data">
                  <template>
                    <v-list-tile-content>
                      <v-list-tile-title>{{
                        data.item.product_name_th
                      }}</v-list-tile-title>
                      <v-list-tile-sub-title>
                        {{ data.item.product_name_en }}</v-list-tile-sub-title
                      >
                    </v-list-tile-content>
                    <v-list-tile-action
                      >THB
                      {{ data.item.product_base_price }}</v-list-tile-action
                    >
                  </template>
                </template>
              </v-autocomplete></v-flex
            >
            <v-flex xs12 sm4 class="pa-1">
              <v-text-field
                v-model.number="form.qty"
                label="Amount"
                hide-details
                color="black"
                type="number"
                :rules="[(v) => !!v || 'Amount is required', rules.onlyNumber]"
              ></v-text-field> </v-flex
          ></v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions
        ><v-spacer></v-spacer
        ><v-btn
          :loading="isLoading"
          @click="submit()"
          color="primary"
          style="border-radius: 10px; width: 120px"
          class="black--text"
          >save</v-btn
        ><v-spacer></v-spacer></v-card-actions></v-card
  ></v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["dialog", "selectedItem", "storeID", "storeName"],
  data() {
    return {
      form: {
        order_id: null,
        product_id: null,
        qty: null,
      },
      productList: [],
      isLoadingProduct: false,
      isLoading: false,
      valid: true,
      rules: {
        onlyNumber: (value) => /^[^\W_]+$/.test(value) || "invalid format",
      },
    };
  },
  watch: {
    async dialog() {
      if (this.dialog == true) {
        console.log(this.selectedItem);
        this.form.order_id = this.selectedItem.detail_order_id;
        this.form.product_id = this.selectedItem.detail_product_id;
        this.form.qty = this.selectedItem.detail_product_quantity;

        this.isLoadingProduct = true;
        this.productList = await this.fetchProductList({
          storeID: this.storeID,
        });
        this.isLoadingProduct = false;
      }
    },
  },
  methods: {
    ...mapActions({
      fetchProductList: "fetchDineIn/fetchProductList",
    }),
    close() {
      this.$emit("onClosed");
    },
    submit() {
      if (!this.$refs.formEditPackage.validate()) return;
      this.isLoading = true;
      let _this = this;
      this.$emit("onSubmit", {
        done() {
          _this.isLoading = false;
        },
        form: this.form,
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
